import React from "react";

import type { CodeBlockDoc as CodeBlockType } from "../../types/blocks";

import { Code } from "../components/Code";

type Props = CodeBlockType & {
  className?: string;
};

export const CodeBlock: React.FC<Props> = ({ className, code, language }) => {
  return (
    <div className={[className, "not-prose"].filter(Boolean).join(" ")}>
      <Code
        code={code}
        language={language && language !== undefined ? language : "typescript"}
      />
    </div>
  );
};
